export default "__VITE_ASSET__CTcM8FDD__"